<div
  class="w-full flex justify-content-center"
  [style.--page-section-background-color]="pageSectionBackground()"
  [class.section-with-background-color]="!!pageSectionBackground()">
  <div class="page-section page-section-x-padded">
    <div
      class="content-banner-container mx-auto"
      [class]="isVerticalPresentation() ? 'vertical-content-banner-container' : 'horizontal-content-banner-container'">
      @if (headline()) {
        <h2>{{ headline() }}</h2>
      }
      @if (subheading()) {
        <h3>{{ subheading() }}</h3>
      }

      @if (headline() || subheading()) {
        <ppg-horizontal-divider></ppg-horizontal-divider>
      }

      @switch (presentation()) {
        @case (ContainerContentBannerPresentation.LARGE) {
          <div class="grid justify-content-start outer-banner-gap">
            @for (card of cards(); track $index) {
              <ppg-large-presentation-content-banner
                class="full-lg-half-width"
                [class]="{
                  'dark-theme': isDarkBackground(),
                  'light-theme': isLightBackground(),
                  'transparent-theme': isTransparentBackground(),
                  'default-theme': isDefaultBackground(),
                }"
                [isResponsive]="true"
                [logo]="logo()"
                [largeComponentContentBanner]="card">
              </ppg-large-presentation-content-banner>
            }
          </div>
        }
        @case (ContainerContentBannerPresentation.SMALL) {
          <div class="grid justify-content-start outer-banner-gap">
            @for (card of cards(); track $index) {
              <ppg-small-presentation-content-banner
                class="full-lg-half-width"
                [class]="{
                  'dark-theme': isDarkBackground(),
                  'light-theme': isLightBackground(),
                  'transparent-theme': isTransparentBackground(),
                  'default-theme': isDefaultBackground(),
                }"
                [isResponsive]="true"
                [logo]="logo()"
                [smallComponentContentBanner]="card">
              </ppg-small-presentation-content-banner>
            }
          </div>
        }
        @case (ContainerContentBannerPresentation.HORIZONTAL_TALL) {
          <div class="flex flex-column">
            @for (card of cards(); track $index) {
              <ppg-horizontal-tall-presentation-content-banner
                [class]="getCardBackgroundClass(content().orderForDefaultTheme, $index)"
                [isResponsive]="true"
                [logo]="logo()"
                [horizontalTallComponentContentBanner]="card"
                [horizontalTallImagePositionRight]="$index % 2 === 0">
              </ppg-horizontal-tall-presentation-content-banner>
            }
          </div>
        }
        @case (ContainerContentBannerPresentation.HORIZONTAL_STANDARD) {
          <div class="flex flex-column outer-banner-gap">
            @for (card of cards(); track $index) {
              <ppg-horizontal-standard-presentation-content-banner
                [class]="getCardBackgroundClass(content().orderForDefaultTheme, $index)"
                [isResponsive]="true"
                [logo]="logo()"
                [horizontalStandardComponentContentBanner]="card"
                [horizontalStandardImagePositionRight]="$index % 2 === 0">
              </ppg-horizontal-standard-presentation-content-banner>
            }
          </div>
        }
        @case (ContainerContentBannerPresentation.HORIZONTAL_STANDARD_50) {
          <div class="flex flex-column outer-banner-gap">
            @for (card of cards(); track $index) {
              <ppg-horizontal-50-50-presentation-content-banner
                [class]="getCardBackgroundClass(content().orderForDefaultTheme, $index)"
                [isResponsive]="true"
                [logo]="logo()"
                [horizontal5050ComponentContentBanner]="card"
                [horizontal5050ImagePositionRight]="$index % 2 === 0">
              </ppg-horizontal-50-50-presentation-content-banner>
            }
          </div>
        }
        @case (ContainerContentBannerPresentation.HORIZONTAL_SHORT) {
          <div class="flex flex-column">
            @for (card of cards(); track $index) {
              <ppg-horizontal-short-presentation-content-banner
                [class]="getCardBackgroundClass(content().orderForDefaultTheme, $index)"
                [isResponsive]="true"
                [horizontalShortComponentContentBanner]="card"
                [logo]="logo()"
                [horizontalShortImagePositionRight]="$index % 2 === 0">
              </ppg-horizontal-short-presentation-content-banner>
            }
          </div>
        }
        @case (ContainerContentBannerPresentation.CAROUSEL) {
          <div>
            <p-carousel
              [value]="cards()"
              [numVisible]="3"
              [numScroll]="3"
              [circular]="false"
              [responsiveOptions]="responsiveOptions"
              ngSkipHydration>
              <ng-template let-product pTemplate="item">
                <ppg-carousel-presentation-content-banner
                  class="flex h-full"
                  [class]="{
                    'dark-theme': isDarkBackground(),
                    'light-theme': isLightBackground(),
                    'transparent-theme': isTransparentBackground(),
                    'default-theme': isDefaultBackground(),
                  }"
                  [isResponsive]="true"
                  [logo]="logo()"
                  [carouselComponentContentBanner]="product">
                </ppg-carousel-presentation-content-banner>
              </ng-template>
            </p-carousel>
          </div>
        }
      }
    </div>
  </div>
</div>
